import {
  getLayoutByIdApi,
  hideLoader,
  showLoader,
} from '@app-store'
import { useCallback, useEffect, useState } from 'react'
import MultiLookupRenderTabs from '../tabs/MultiLookupRenderTabs'
import { MultiLookup360WrapperTypes } from '../../types/types'
import { useAppDispatch } from '../../utils/agent.store'

const Multilookup360Wrapper = ({
  heading,
  entityId,
  listViewId,
  editViewId,
  relationshipIdentifier,
  lookupKeyname,
  parentEditLayoutId,
  // isTab = false,
  recordId,
  entityIdParent,
  isAssign,
  tabIndexMap,
  disableFilters,
  isViewEntity = false,
}: MultiLookup360WrapperTypes) => {
  const [isAccordionOpen, setIsAccordionOpen] = useState<boolean>(false)
  const [listingLayout, setListingLayout] = useState()
  const [editLayout, setEditLayout] = useState()
  const dispatch = useAppDispatch()
  const fetchLayout = async () => {
    try {
      dispatch(showLoader())
      const responseList = await getLayoutByIdApi({
        entityId,
        layoutId: listViewId,
      })
      if (responseList?.data) {
        setListingLayout(responseList?.data)
      }
      const responseEdit = await getLayoutByIdApi({
        entityId,
        layoutId: editViewId,
      })
      if (responseEdit?.data) {
        setEditLayout(responseEdit?.data)
      }
    } catch (err) {
      console.error(err)
    } finally {
      dispatch(hideLoader())
    }
  }

  const handleAccordionClick = useCallback((accordionExpanded: boolean) => {
    setIsAccordionOpen(accordionExpanded)
  }, [])

  useEffect(() => {
    if (entityId && isAccordionOpen && !listingLayout) {
      fetchLayout()
    }
  }, [entityId, isAccordionOpen])

  return (
    <MultiLookupRenderTabs
      heading={heading}
      listingLayout={listingLayout ?? null}
      editLayout={editLayout ?? null}
      relationIdentifier={relationshipIdentifier}
      lookupKeyname={lookupKeyname}
      entityIdMultilookup={entityId}
      editIdMultilookup={parentEditLayoutId}
      recordId={recordId}
      entityId={entityIdParent}
      isAssign={isAssign}
      tabIndexMap={tabIndexMap}
      handleAccordionClick={handleAccordionClick}
      disableFilters={disableFilters}
      isViewEntity={isViewEntity}
    />
    // Testing this on qa will remove after testing
    // <MultiLookupRender360
    //   heading={heading}
    //   listingLayout={listingLayout}
    //   editLayout={editLayout}
    //   relationIdentifier={relationshipIdentifier}
    //   lookupKeyname={lookupKeyname}
    //   entityIdMultilookup={entityId}
    //   editIdMultilookup={parentEditLayoutId}
    // />
  )
}

export default Multilookup360Wrapper
